import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "vueinstallapp" }
const _hoisted_2 = {
  key: 0,
  class: "descreferer"
}
const _hoisted_3 = { class: "infos" }
const _hoisted_4 = {
  key: 1,
  class: "descreferer"
}
const _hoisted_5 = {
  key: 2,
  class: "d-flex flex-column gap-2"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column cadre1 flex-fill"
}
const _hoisted_7 = { class: "d-flex flex-column cadre3" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex flex-column align-items-center gap-1"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "d-flex flex-row gap-3" }
const _hoisted_12 = { class: "d-flex flex-column align-items-center or flex-fill" }
const _hoisted_13 = { class: "d-flex flex-row justify-content-center or" }
const _hoisted_14 = { class: "d-flex flex-column align-items-center or flex-fill" }
const _hoisted_15 = { class: "d-flex gap-3" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex flex-column cadre1 flex-fill"
}
const _hoisted_17 = { class: "d-flex flex-column gap-4 cadre3" }
const _hoisted_18 = { class: "d-flex flex-column gap-1" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "description" }
const _hoisted_22 = { class: "d-flex flex-column gap-1" }
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "description"
}
const _hoisted_25 = {
  key: 1,
  class: "d-flex flex-column cadre1 flex-fill"
}
const _hoisted_26 = { class: "d-flex flex-column gap-4 cadre3" }
const _hoisted_27 = { class: "d-flex flex-column gap-1" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "d-flex flex-column" }
const _hoisted_30 = { class: "description" }
const _hoisted_31 = { class: "d-flex flex-column gap-1" }
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  key: 1,
  class: "description"
}
const _hoisted_34 = {
  key: 3,
  class: "d-flex flex-column gap-3"
}
const _hoisted_35 = { class: "d-flex flex-column cadre1" }
const _hoisted_36 = { class: "d-flex flex-column cadre3" }
const _hoisted_37 = ["innerHTML"]

import { ref, Ref, onMounted } from 'vue';
    import { InstallAppApiViewModel } from '../../Views/startdetection/index';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'vueinstallapp',
  props: {
    isinstallauto: { type: Boolean },
    view_loginmodal_infos: {},
    view_startdetect_modalinstalldesc: {},
    viewappli: {},
    dc_descpilotesreferer: {},
    view_startdetect_modalhasinstallauto: {},
    view_startdetect_modalhasinstallmsi: {},
    dcstartdetect_modal_install_mandatory: {},
    view_startdetect_modal_manual_title: {},
    view_startdetect_modal_manual_desc: {},
    view_startdetect_modalor: {},
    view_startdetect_modal_subtitle_32: {},
    view_startdetect_modal_subtitle_64: {}
  },
  setup(__props: any) {

    const props = __props;
    const viewappli: Ref<InstallAppApiViewModel | null> = ref(null);
    const dc_descpilotesreferer: Ref<string> = ref("");
    const view_loginmodal_infos: Ref<string> = ref("");
    const view_startdetect_modalinstalldesc: Ref<string> = ref("");
    const hasDownloaded: Ref<boolean | null> = ref(null);

    function downloaded(auto: boolean) {
        hasDownloaded.value = auto;
    }

    onMounted(() => {
        $('#dc_installappdialog').on('show.bs.modal', function (e: any) {
            hasDownloaded.value = null;
        });
        $('#dc_appclouddialog').on('show.bs.modal', function (e: any) {
            hasDownloaded.value = null;
        });
        
           
            viewappli.value=props.viewappli;
            dc_descpilotesreferer.value = props.dc_descpilotesreferer;
            view_loginmodal_infos.value = props.view_loginmodal_infos;
            view_startdetect_modalinstalldesc.value = props.view_startdetect_modalinstalldesc;
        });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (dc_descpilotesreferer.value!='')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(view_loginmodal_infos.value), 1 /* TEXT */),
          _createTextVNode(_toDisplayString(dc_descpilotesreferer.value), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isinstallauto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(view_startdetect_modalinstalldesc.value), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (viewappli.value && hasDownloaded.value===null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.isinstallauto)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (viewappli.value.installautobut)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", null, [
                          _createElementVNode("a", {
                            class: "btn btn-modalbottom",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (downloaded(true))),
                            href: viewappli.value.installautobut.url
                          }, _toDisplayString(viewappli.value.installautobut.name), 9 /* TEXT, PROPS */, _hoisted_9)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (!_ctx.isinstallauto)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.view_startdetect_modal_manual_title), 1 /* TEXT */),
                _createElementVNode("div", {
                  class: "descreferer",
                  innerHTML: _ctx.view_startdetect_modal_manual_desc
                }, null, 8 /* PROPS */, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.view_startdetect_modal_subtitle_32), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.view_startdetect_modalor), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.view_startdetect_modal_subtitle_64), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (viewappli.value.ManualInstall32)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            (viewappli.value.ManualInstall32.UrlEdgeView)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "btn btn-modalbottom",
                                  href: viewappli.value.ManualInstall32.UrlEdgeView
                                }, _toDisplayString(viewappli.value.ManualInstall32.NameEdgeView), 9 /* TEXT, PROPS */, _hoisted_19))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.dcstartdetect_modal_install_mandatory), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString(viewappli.value.ManualInstall32.DescriptionEdgeView), 1 /* TEXT */)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            (viewappli.value.ManualInstall32.UrlAgent)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "btn btn-modalbottom",
                                  href: viewappli.value.ManualInstall32.UrlAgent
                                }, _toDisplayString(viewappli.value.ManualInstall32.NameAgent), 9 /* TEXT, PROPS */, _hoisted_23))
                              : _createCommentVNode("v-if", true),
                            (viewappli.value.ManualInstall32.UrlAgent)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(viewappli.value.ManualInstall32.DescriptionAgent), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (viewappli.value.ManualInstall64)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            (viewappli.value.ManualInstall64.UrlEdgeView)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "btn btn-modalbottom",
                                  href: viewappli.value.ManualInstall64.UrlEdgeView
                                }, _toDisplayString(viewappli.value.ManualInstall64.NameEdgeView), 9 /* TEXT, PROPS */, _hoisted_28))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.dcstartdetect_modal_install_mandatory), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString(viewappli.value.ManualInstall64.DescriptionEdgeView), 1 /* TEXT */)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            (viewappli.value.ManualInstall64.UrlAgent)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "btn btn-modalbottom",
                                  href: viewappli.value.ManualInstall64.UrlAgent
                                }, _toDisplayString(viewappli.value.ManualInstall64.NameAgent), 9 /* TEXT, PROPS */, _hoisted_32))
                              : _createCommentVNode("v-if", true),
                            (viewappli.value.ManualInstall64.UrlAgent)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(viewappli.value.ManualInstall64.DescriptionAgent), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (viewappli.value && hasDownloaded.value!==null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              (hasDownloaded.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    innerHTML: _ctx.view_startdetect_modalhasinstallauto
                  }, null, 8 /* PROPS */, _hoisted_37))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})